import Vue from 'vue'
import {api} from '../../api/electronic-control'
import {registerConfig, SHOW_IN} from '../../../components/common/di-ding'
import {commonConfig, routeNameOfDi} from '../common'
import DatePickerBox from '../electronic-record/date-picker-box'

Vue.component('date-picker-box', DatePickerBox)

const mapping = {
  enterpriseName: {
    type: 'list',
    label: '住户',
    nullable: false,
    list: {
      key: {
        dataLabel: 'enterpriseName',
        dataValue: 'code',
        detailLabel: 'enterpriseName',
        detailValue: 'code'
      },
      fetch: api.getEnterpriseList,
    },
  },
  year: {
    label: '年',
    showIn: [SHOW_IN.CENTER]
  },
  month: {
    label: '月',
    showIn: [SHOW_IN.CENTER]
  },
  monthDate: {
    label: '出账年月',
    type: 'monthDate',
    showIn: [SHOW_IN.CREATE, SHOW_IN.MODIFY],
    nullable: false,
    onDataLoaded (data) {
      let dataMonth = data.month < 10 ? '0' + data.month : data.month
      data.monthDate = `${data.year}-${dataMonth}`
    },
    beforeDataIsPost (data) {
      data.year = data.monthDate.split('-')[0]
      data.month = data.monthDate.split('-')[1]
    }
  },
  totalData: {
    label: '总度数',
    nullable: false,
  },
  money: {
    label: '应缴费用',
    nullable: false,
  },
  state: {
    label: '缴费状态',
    showIn: [SHOW_IN.CENTER],
    mapList: {
      map: {
        '0': '未缴费',
        '1': '已缴费'
      }
    }
  }
}

const config = {
  breadcrumb: [{
    value: '智慧用电',
    name: 'electronic-config'
  }, {
    value: '数据导入',
  }],
  center: {
    opBar: [ // 多少个元素代表多少行
      [ // 仅支持 flex布局
        {
          type: 'render',
          renderContent (h, type, data, that) {
            const onChange = val => {
              let chooseYear = val.split('-')[0]
              let chooseMonth = val.split('-')[1]
              that.requestBody.year = chooseYear
              that.requestBody.month = chooseMonth
              this.$emit('change')
            }
            return <date-picker-box style={{marginBottom: '14px'}}
                                    type="month" onChange={onChange}/>
          },
        },
        // {
        //   type: 'search-tree',
        //   label: '宿舍',
        //   searchKey: 'deptId',
        //   fetchDetail: () => api.getDormitoryList()
        //     .then(list => {
        //       list.forEach(it => {
        //         it._value = it.id
        //         it._label = it.dormitoryName
        //       })
        //       return list
        //     })
        // },
        {
          type: 'search-selector',
          label: '缴费状态',
          searchKey: 'state',
          fetchDetail: () => Promise.resolve(
            [{
              '_value': '0',
              '_label': '未缴费'
            }, {
              '_value': '1',
              '_label': '已缴费'
            }]
          )
        }
      ],
      [
        [
          {
            type: 'button-add',
            label: '添加电费',
            onClick () {
              this.routerPush('diDingCreate', {diName: 'electronic-import'})
            }
          },
          {
            type: 'button-uploadTable',
            label: '导入',
            uploadUrl: api.importElectronicRecord(),
          },
          {
            type: 'button-download',
            label: '导出',
            getDownloadUrl: (requestBody) => api.exportElectronicRecordData(requestBody),
            download: '电费缴费记录'
          }
        ],
        [
          {type: 'input-search', label: '住户', searchKey: 'searchKey'},
        ]
      ]
    ],
    table: {
      operations: ['detail', 'delete']
    }
  },
  current: {
    title: '查看当前缴费数据'
  },
  create: {
    title: '添加电费数据'
  },
  modify: {
    title: '修改电费数据'
  },

  get: requestBody => api.getElectronicRecordPage(requestBody),
  delete: strId => api.deleteElectronicRecordByIds(strId),
  getCurrent: id => api.getElectronicRecordById(id),
  post: requestBody => api.addElectronicRecord(requestBody),
  patch: data => api.updateElectronicRecordByIds(data),
  mapping
}

registerConfig(routeNameOfDi.ELECTRONIC_IMPORT, config)



// WEBPACK FOOTER //
// ./src/view/ElectronicControl/electronic-import/electronic-import.js